import React, { useState } from 'react';
import { Header, Card, Image, Dropdown, Grid, Input } from 'semantic-ui-react';

const curation = (modaldata, handleChange) => {
  const options = [{ key: 1, text: 'LPA', value: 1 }];
  // console.log(modaldata.modaldata.avgComp, "nkjnk");
  // const [data, setData] = useState({ avgComp: "" });
  // const handleChange = (e) => {
  //   console.log(e.target.value, "zoro");
  //   setData({
  //     [e.target.name]: e.target.value,
  //   });
  // };
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Header as="h2">Product Designer - PhonePe</Header>
      </div>
      <Card
        fluid
        className="basic-info-dropdown cardui"
        style={{ padding: '4% 2%', height: '100%' }}
      >
        <Header as="h4">Compensation Analysis</Header>

        <Card.Content>
          <Grid>
            <Grid.Column computer={8}>
              <p style={{ paddingBottom: '10px' }}>AVARAGE COMPENSATION RANGE</p>

              <Grid>
                <Grid.Column computer={8}>
                  <Grid>
                    <Grid.Column computer={4}>
                      <Dropdown placeholder="LPA" compact selection options={options} />
                    </Grid.Column>
                    <Grid.Column computer={12}>
                      {/* <Input defaultValue={modaldata.modaldata.avgcomp} /> */}
                      <Input
                        onChange={handleChange}
                        // defaultValue={
                        //   modaldata.modaldata ? modaldata.modaldata.avgcomp : ""
                        // }
                        value={modaldata.modaldata.avgComp}
                      />
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
                <Grid.Column computer={8}>
                  <Grid>
                    <Grid.Column computer={4}>
                      <Dropdown placeholder="LPA" compact selection />
                    </Grid.Column>
                    <Grid.Column computer={12}>
                      <Input />
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column computer={8}>
              <p style={{ paddingBottom: '10px' }}>TALENTS EXPECTED COMPENSATION RANGE</p>

              <Grid>
                <Grid.Column computer={8}>
                  <Grid>
                    <Grid.Column computer={4}>
                      <Dropdown placeholder="LPA" compact selection />
                    </Grid.Column>
                    <Grid.Column computer={12}>
                      <Input
                        defaultValue={modaldata.modaldata ? modaldata.modaldata.expcomp : ''}
                      />
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
                <Grid.Column computer={8}>
                  <Grid>
                    <Grid.Column computer={4}>
                      <Dropdown placeholder="LPA" compact selection />
                    </Grid.Column>
                    <Grid.Column computer={12}>
                      <Input />
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
        </Card.Content>
      </Card>
    </div>
  );
};

export default curation;
